import { useState } from 'react';
import gql from 'graphql-tag';
import { sendAnalyticsDataQuery } from '../queries';

const query = gql`
  query ($path: Path!) {
    phones @rest(type: "Phones", path: $path) {
      phones
    }
  }
`;

const getFullPhoneNumbers = (
  id,
  residenceId,
  client,
  path,
  targetType,
  agencyId,
  isWebview
) => {
  const [phonesShown, setPhonesShown] = useState(null);
  const [isVisible, setIsVisible] = useState(false);
  const isAgencyPage = targetType === 'AGENCY';
  const isResidencePage = targetType === 'RESIDENCE';
  let targetId;

  switch (true) {
    case isAgencyPage:
      targetId = agencyId;
      break;
    case isResidencePage:
      targetId = residenceId;
      break;
    default:
      targetId = id;
  }

  const callPhones = (phones, index, triggerButton, isCalled) => {
    if (isResidencePage && isCalled) {
      return;
    }

    if (phones?.length > 1 && triggerButton !== 'contact') {
      setIsVisible(true);
    } else {
      window.open(`tel:${phones[index]?.replace(/\D/g, '')}`, '_top');
    }
  };

  const sendAnalyticsData = (triggerButton, phones) => {
    try {
      client.mutate({
        mutation: sendAnalyticsDataQuery,
        variables: {
          targetId,
          targetType,
          sourceLink: `${window.location?.origin}${window.location?.pathname}`,
          triggerButton,
          phones,
          eventType: 'SHOW_PHONES',
          source: isWebview ? 'APP' : 'MOBILE'
        },
        fetchPolicy: 'network-only'
      });
    } catch (error) {
      console.log(`Error occurred: ${error}`);
    }
  };

  const fetchData = async (e, index = 0, isCalled, triggerButton) => {
    try {
      client
        .query({
          query,
          variables: {
            path: `${path}/${id}/phones?react=true`
          },
          fetchPolicy: 'network-only'
        })
        .then(response => {
          const { phones } = response.data;

          callPhones(phones?.phones, index, triggerButton, isCalled);

          sendAnalyticsData(triggerButton, phones?.phones);
          setPhonesShown(phones?.phones);
        });
    } catch (error) {
      console.log(`Error occurred: ${error}`);
    }
  };

  const onClickHandler =
    (index = 0, isCalled) =>
    async (e, triggerButton = null, gallery = false) => {
      if (!gallery) {
        e.preventDefault();
        e.persist();
      }

      if (phonesShown) {
        callPhones(phonesShown, index, triggerButton, isCalled);
        return null;
      }
      await fetchData(e, index, isCalled, triggerButton);
    };

  return {
    onClickHandler,
    phonesShown,
    setPhonesShown,
    setIsVisible,
    isVisible
  };
};

export default getFullPhoneNumbers;
